/**
 * Front-end behavior for AOE Front Blocks.
 *
 * The header / front-page-body / footer markup is rendered server-side by PHP
 * (block render.php files) so search engines see real content in the initial
 * HTML response. This script wires up the small amount of interactivity that
 * actually needs JavaScript: the Hero carousel and the mobile menu toggle.
 *
 * Submenu hover on desktop is pure CSS (group-hover) — no JS needed.
 */

import './styles/index.css'

function initHeroCarousel(carousel: HTMLElement): void {
  const slides = Array.from(
    carousel.querySelectorAll<HTMLElement>('[data-aoe-hero-slide]'),
  )
  const dots = Array.from(
    carousel.querySelectorAll<HTMLElement>('[data-aoe-hero-dot]'),
  )
  const prev = carousel.querySelector<HTMLElement>('[data-aoe-hero-prev]')
  const next = carousel.querySelector<HTMLElement>('[data-aoe-hero-next]')

  if (slides.length === 0) return

  const total = slides.length
  let current = 0

  function goTo(index: number): void {
    current = ((index % total) + total) % total
    slides.forEach((slide, i) => {
      const active = i === current
      slide.classList.toggle('opacity-100', active)
      slide.classList.toggle('opacity-0', !active)
    })
    dots.forEach((dot, i) => {
      const active = i === current
      dot.classList.toggle('bg-white', active)
      dot.classList.toggle('w-8', active)
      dot.classList.toggle('bg-white/50', !active)
    })
  }

  prev?.addEventListener('click', () => goTo(current - 1))
  next?.addEventListener('click', () => goTo(current + 1))
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => goTo(i))
  })

  // 5-second auto-rotate, paused while the user hovers the carousel.
  let timer = window.setInterval(() => goTo(current + 1), 5000)
  carousel.addEventListener('mouseenter', () => {
    window.clearInterval(timer)
  })
  carousel.addEventListener('mouseleave', () => {
    timer = window.setInterval(() => goTo(current + 1), 5000)
  })
}

function initMobileMenu(): void {
  const toggle = document.querySelector<HTMLElement>('[data-aoe-mobile-toggle]')
  const drawer = document.querySelector<HTMLElement>('[data-aoe-mobile-menu]')
  if (!toggle || !drawer) return

  const menuIcon = toggle.querySelector<HTMLElement>('[data-aoe-icon="menu"]')
  const closeIcon = toggle.querySelector<HTMLElement>('[data-aoe-icon="close"]')

  toggle.addEventListener('click', () => {
    const isOpening = drawer.classList.contains('hidden')
    drawer.classList.toggle('hidden', !isOpening)
    menuIcon?.classList.toggle('hidden', isOpening)
    closeIcon?.classList.toggle('hidden', !isOpening)
    toggle.setAttribute('aria-expanded', isOpening ? 'true' : 'false')
    toggle.setAttribute('aria-label', isOpening ? 'Close menu' : 'Open menu')
  })
}

function init(): void {
  document
    .querySelectorAll<HTMLElement>('[data-aoe-hero]')
    .forEach(initHeroCarousel)
  initMobileMenu()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
